/* eslint-disable no-unused-vars */
import axios from 'axios';
import { authorizeToken, localLoginToken } from '../../authorization/login';
// eslint-disable-next-line import/prefer-default-export
export async function fetchData(url, isAuth = true) {
    let res;
    try {
        if (isAuth) {
            res = await axios.get(url, {
                headers: {
                    Authorization: `Basic ${localLoginToken}`,
                },
            });
        } else {
            res = await axios.get(url);
        }

        return res;
    } catch (error) {
        return error;
    }
}
